import React from 'react'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { MotifAvatar } from '@ey-xd/motif-react'
import { useGetUserPhotoQuery } from '@/services/graphApi'

interface UserAvatarProps {
  adIdentifier?: string | null
  label: string
  profileImage?: string | null
  className?: string
  title?: string
}

// Only hits Graph when no profileImage was already supplied (e.g. search
// results) - RTK Query then caches the result per adIdentifier in Redux.
export const UserAvatar: React.FC<UserAvatarProps> = ({
  adIdentifier,
  label,
  profileImage,
  className,
  title,
}) => {
  const { data: fetchedPhoto } = useGetUserPhotoQuery(
    profileImage || !adIdentifier ? skipToken : adIdentifier,
  )

  return (
    <MotifAvatar
      src={profileImage ?? fetchedPhoto ?? undefined}
      userName={label}
      className={className}
      title={title ?? label}
    />
  )
}
